import React from 'react';
import '../landing/HwpDemoSection.css';

// 실제 AI 한글 결과(가정통신문)를 한글 편집 패널 모습 그대로 보여준다. 홈 섹션과 데모 카드가 같이 쓴다.
export const HWP_DEMO_FORM_CELLS = [
  { label: '체험학습일', before: '[날짜]', after: '5월 15일(금)' },
  { label: '장소', before: '[장소]', after: '경주 신라문화원 일대' },
  { label: '대상', before: '[학년]', after: '4학년 전체' },
  { label: '출발 시각', before: '[시각]', after: '오전 9시, 학교 출발' },
  { label: '준비물', before: '[준비물]', after: '도시락, 물, 간식' },
  { label: '동의서 제출 기한', before: '[날짜]', after: '5월 11일(월)까지' },
];

const HWP_MENUS = ['파일', '편집', '보기', '입력', '서식', '쪽', '표', '도구'];
const HWP_TOOLS = ['개요 1', '대표', '함초롬돋움', '10.0 pt', '160 %'];

const HwpDocPane = ({ filledCount, filling = false, done = false }) => (
  <>
    <div className="hwp-demo-panel-header">
      <h4 className="hwp-demo-panel-title">가정통신문_양식.hwpx</h4>
      <span className="hwp-demo-panel-close" aria-hidden="true">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </span>
    </div>
    <div className="hwp-demo-menubar" aria-hidden="true">
      {HWP_MENUS.map((menu) => <span key={menu}>{menu}</span>)}
    </div>
    <div className="hwp-demo-toolbar" aria-hidden="true">
      {HWP_TOOLS.map((tool) => <span key={tool} className="hwp-demo-tool-select">{tool}</span>)}
      <span className="hwp-demo-tool-btn is-bold">가</span>
      <span className="hwp-demo-tool-btn is-italic">가</span>
      <span className="hwp-demo-tool-btn is-underline">가</span>
    </div>
    <div className="hwp-demo-ruler" aria-hidden="true" />

    <div className="hwp-demo-panel-body">
      <div className="hwp-demo-page">
        <h5 className="hwp-demo-doc-title">4학년 봄소풍 안내</h5>
        <p className="hwp-demo-doc-text">
          학부모님, 안녕하십니까? 학생들이 자연 속에서 우리 문화를 직접 보고 느낄 수 있도록 다음과 같이 봄소풍을 실시하고자 합니다.
        </p>
        <p className="hwp-demo-doc-heading">□ 봄소풍 안내</p>
        <table className="hwp-demo-form-table">
          <thead>
            <tr><th>구분</th><th>내용</th></tr>
          </thead>
          <tbody>
            {HWP_DEMO_FORM_CELLS.map((cell, i) => {
              const isFilled = filledCount > i;
              const isFilling = filling && filledCount === i + 1;
              return (
                <tr key={cell.label}>
                  <td className="label-cell">{cell.label}</td>
                  <td className={`value-cell${isFilled ? ' filled' : ''}${isFilling ? ' filling' : ''}`}>
                    {isFilled ? cell.after : cell.before}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <p className="hwp-demo-doc-heading">□ 협조 사항</p>
        <p className="hwp-demo-doc-text is-item">○ 오전 8시 40분까지 등교할 수 있도록 도와주시기 바랍니다.</p>
        <p className="hwp-demo-doc-text is-item">○ 편한 복장과 운동화를 착용해 주십시오.</p>
      </div>
    </div>

    <div className="hwp-demo-statusbar" aria-hidden="true">
      <span>1 / 1 쪽</span>
      <span>구역: 1 / 1</span>
    </div>
    <div className="hwp-demo-panel-footer">
      <span className={`hwp-demo-panel-download${done ? ' active' : ''}`}>한글 파일로 저장</span>
    </div>
  </>
);

export default HwpDocPane;
